module.exports = __webpack_public_path__ + "img/paper.8a9bafcc.svg";